import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import GoogleMapReact from 'google-map-react'
import settings from "settings"
import _ from 'lodash'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'
import clone from "clone"

class HeatTraffic extends Component {

	constructor(props) {
		super(props)

		this.state = {
			heat: []
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.payload.sales.current.length !== this.props.payload.sales.current.length) {
			this.buildData()
		}
	}

	componentDidMount() {
		this.buildData()
	}

	buildTable = () => {
		var data = []
		var ret = {}
		_.forEach(this.props.payload.traffic.current.entries, v => {
			if(!v.zip) { return }
			if(!_.has(ret, `${v.zip}`)) {
				ret[v.zip] = {count: 0}
			}
			ret[v.zip].count++
		})
		_.forEach(ret, (r, k) => {
			data.push({zip: k, total: r.count})
		})
		return data
	}

	buildData = () => {
		var points = {
			positions: [],
			options: {
				radius:settings.heatMapRadius
			}
		}
		var ret = {}
        _.forEach(this.props.payload.traffic.current.entries, v => {
			if(v.lat == null || v.lng == null) { return }
            if (!v.zip) {
                return
            }
            if (!_.has(ret, `${v.zip}`)) {
                ret[v.zip] = { count: 0, lat: 0, lng: 0 }
            }
			ret[v.zip].count++
			ret[v.zip].lat = v.lat,
			ret[v.zip].lng = v.lng
        })
		_.forEach(ret, (r) => {
			var i
			for(i = 1; i <= r.count; i++) {
				points.positions.push({lat:r.lat, lng:r.lng})
			}
		})
			
		this.setState({heat: points})
	}

	render() {
		const columns = [
            {
                Header: 'Zip',
                accessor: 'zip',
                Cell: ({ row }) => (<Link to={{ pathname: `/zipcode/${row.zip}` }}>{row.zip}</Link>)
            },
            {
                Header: 'Total',
                accessor: 'total',
                sort: 'asc'
            }
        ]
		
		if(this.props.payloadStatus){
			return (
				<div className="sales">
					<Title title="Traffic Heat Map" />
					<div className="heatmap">
						<GoogleMapReact
							bootstrapURLKeys={{
								key: settings.gmapsApiKey,
								libraries: "visualization",
							}}
							defaultCenter={settings.mapsCenter}
							defaultZoom={10}
							heatmapLibrary={true}
							heatmap={this.state.heat}
						/>
					</div>
					<div className="content">
						<h2>Zip Code Table</h2>
						<ReactTable
							data={this.buildTable()}
							columns={columns}
							defaultPageSize={9}
							loadingText=""
							defaultSorted={[
								{
									id: "total",
									desc: true,
								},
							]}
						/>
					</div>
				</div>
			)
		}
		else {
			return('')
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(HeatTraffic)
